import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import FontAwesome from 'react-fontawesome';
import 'font-awesome/css/font-awesome.css';

import { withStyles } from '@material-ui/core/styles';
import CalendarIcon from '@material-ui/icons/AccessTime';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';

import styles from './notifications-tab.style';
import scss from './notifications-tab.module.scss';

class NotificationsTab extends Component {
  render() {
    const {
      classes
    } = this.props;

    return (
      <div className={scss['portal-notifications-wrapper']}>        
          <ul>
            <li>
              <p><strong>Lorem ipsum</strong> dolor sit amet, <strong>consectetur</strong>
              adipiscing elit, sed do eiusmod tempor 
              <span><CalendarIcon/> about an hour ago</span>
              </p>
            </li>
            <li className={scss['read-msg']}>
              <p><strong>Lorem ipsum</strong> dolor sit amet, <strong>consectetur</strong>
              adipiscing elit, sed do eiusmod tempor 
              <span><CalendarIcon/> about an hour ago</span>
              </p>
            </li>
            <li>
              <p><strong>Lorem ipsum</strong> dolor sit amet,
              <span><CalendarIcon/> about an hour ago</span>
              </p>
            </li>
          </ul>        
      </div>
    );
  }
}

NotificationsTab.propTypes = {
  classes: PropTypes.shape({}).isRequired
};

export default withStyles(styles, { withTheme: true })(NotificationsTab);



// WEBPACK FOOTER //
// ./src/layouts/components/notification-sidenav/notifications-tab.component.js